import { render, staticRenderFns } from "./tab-budget.vue?vue&type=template&id=0fccc41b&"
import script from "./tab-budget.vue?vue&type=script&lang=js&"
export * from "./tab-budget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports